import MantineImage from '../../components/mantine/image';
import { TextInput, PasswordInput, Button, Container, Paper, Group, Center, Text, Box } from '@mantine/core';
import { PlaceholderUi, validateEmail } from "../../helpers/common";
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/jb-logo.svg'
import RightImage from '../../assets/images/login-right-bg.svg'
import RightArrow from '../../assets/images/login-arw.svg'
import UserIcon from '../../assets/images/user-ico.svg'
import LockIcon from '../../assets/images/password-ico.svg'
interface iForm {
  handleChange?: any,
  submitLogin: any,
  formData: any
}
const Form = ({ handleChange, formData, submitLogin  }: iForm) => {
  const navigate = useNavigate();
  
  return <Container fluid className='overflow-hidden flex h-screen p-0 item-center justify-between bg-[#041E42] w-full'>
    <Group className='relative h-full flex-col max-w-[435px] w-full justify-center'>
      <Paper className='bg-transparent w-full'>
        <Center mb="2rem">
          <MantineImage
            src={Logo}
            className="max-w-[130px] w-full"
          />
        </Center>
        <form onSubmit={submitLogin}>
          <Group mb='lg' className='bg-[#2F7FE2] flex-col rounded-tr-[46px] rounded-br-[46px] p-8 flex-1 w-full item-start'>
            <TextInput
              {...formData?.getInputProps('userName')}
              label="Customer ID"
              placeholder="Enter customer ID"
              leftSection={<MantineImage src={UserIcon} width={18} className="mx-2" />}
              required
              w={'100%'}
              styles={{
                label: { color: 'white', marginBottom: '0.5rem', fontSize: '13px', lineHeight: '16px', fontFamily: 'Gantari-Bold' },
                input: { backgroundColor: 'white', padding: '10px', paddingLeft: 34, height: 46, width: '100%', maxWidth: '370px' },
              }}
              mb="sm"
              className='custom-placeholder'
              //classNames={{ input: `${PlaceholderUi}`, label: "text-sm" }}
              value={formData?.values?.userName}
              onChange={(event: any) => formData.setFieldValue('userName', event.currentTarget?.value)}
            />

            <PasswordInput
              {...formData?.getInputProps('password')}
              label="Password"
              placeholder="xxxxxxxxxxxxxx"
              leftSection={<MantineImage src={LockIcon} width={18} className="mx-2" />}
              required
              w={'100%'}
              styles={{
                label: { color: 'white', marginBottom: '0.5rem', fontSize: '13px', lineHeight: '16px', fontFamily: 'Gantari-Bold' },
                input: { backgroundColor: 'white', padding: '10px', paddingLeft: 34, height: 46, width: '100%', maxWidth: '370px' },
              }}
              mb="sm"
              className='custom-placeholder'
            />
            <Text              
                className="text-white text-sm cursor-pointer underline"
                onClick={() => navigate('/forgotpassword')}
              >
                Forgot Password?
              </Text>
          </Group>
          <Group>
            <Button
              fullWidth
              size="md"
              style={{ backgroundColor: '#FF5C39', color: 'white', borderRadius: '0px 16px 16px 0px', height: 54, fontSize: '1.125rem' }}
              onClick={submitLogin}
              type='submit'
            >
              Authentication
              <MantineImage
                src={RightArrow}
                style={{ marginLeft: '20px', width: '40px' }}
              />
            </Button>
          </Group>
        </form>
      </Paper>
      <Text className='text-xs text-white absolute bottom-2 left-0 text-center w-full'>© 2025 jb associates</Text>
    </Group>
    <Group className='sm-hidden mr-[20px]'>
      <Box maw={227} mx="auto" className='pt-[100px]'>
        <div className="curve-custom" style={{backgroundImage: `url(${RightImage})`,}}/>
      </Box>
    </Group>
  </Container>
}
export default Form;